import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { Form } from "../../common/Form";
import { Panel } from "primereact/panel";
import { InputTextarea } from "primereact/inputtextarea";
import { CommonDialog } from "../../common/CommonDialog";
import { useTranslation } from "react-i18next";

export function RubricLink({rubric,onChange}){
    return <Rubric rubric={rubric} onChange={onChange}/>
}
export function Rubric({rubric,onChange})
{
    const {t}=useTranslation();
    const lvls=[{name:null,score:0},{name:null,score:1},{name:null,score:2}];

    const rubricTypeOptions=[
        {label:t('RubricType.ANALYTIC'),value:'ANALYTIC'},
        {label:t('RubricType.HOLISTIC'),value:'HOLISTIC'}
    ];

    const rowHeader=()=>{
        var cells=[];
        cells.push(<><th></th><th></th></>);
        for(var c=1;c<=rubric.levelCount;c++)
            cells.push(<th>Level: {c}</th>);
        return cells;
    }
    const onLevelName=(e,c)=>{
        if(rubric.levels[c-1] == undefined)
            rubric.levels[c-1]={};
        rubric.levels[c-1].name = e.target.value;
        _onChange(rubric);
    }
    const onScore=(e,c)=>{
        if(rubric.levels[c-1] == undefined)
            rubric.levels[c-1]={};
        rubric.levels[c-1].score = e.target.value;
        _onChange(rubric);
    }
    const onCrtName=(e,r)=>{
        if(rubric.criteria[r-1] == undefined)
            rubric.criteria[r-1]={};
        rubric.criteria[r-1].name = e.target.value;
        _onChange(rubric);
    }
    const onCrtScore=(e,r)=>{
        if(rubric.criteria[r-1] == undefined)
            rubric.criteria[r-1]={};
        rubric.criteria[r-1].score = e.target.value;
        _onChange(rubric);
    }
    const onDescrChange=(e,r,c)=>{
        console.log('onDescrChange:'+r+' '+c+' '+e.target.value);
        var descr=[...rubric.descr];
        descr[r-1][c-1]=e.target.value;
        rubric.descr = descr;
        _onChange(rubric);
    }
    const levelNames=()=>{
        var cells=[];
        cells.push(<><th></th></>);
        for(var c=1;c<=rubric.levelCount;c++)
        {
            if(rubric.levels[c-1] == undefined)
                rubric.levels[c-1] = {};
            var name = rubric.levels[c-1].name;
            const ind = c;
            cells.push(<th><InputText placeholder={'Level: '+c} value={name} onChange={(e)=>onLevelName(e,ind)}/></th>);
        }
        return cells;
    }    
    const scores=()=>{
        var cells=[];
        cells.push(<><th>{t('Level_Score')}</th></>);
        for(var c=1;c<=rubric.levelCount;c++)
        {
            var score = rubric.levels[c-1].score;
            const ind = c;
            cells.push(<th><InputNumber value={score} onValueChange={(e)=>onScore(e,ind)}/></th>);
        }
        return cells;
    }    
    const rows=()=>{
        var rows=[];
        console.log("rows");
        for(var r=1;r<=rubric.criteriaCount;r++)
        {
            var cells=[];
            //cells.push(<th>{r}</th>);
            const row=r;
            const crtName=rubric.criteria[r-1]!=undefined?rubric.criteria[r-1].name:undefined;
            const crtScore=rubric.criteria[r-1]!=undefined?rubric.criteria[r-1].score:undefined;

            cells.push(
                <th className="flex flex-column gap-1" key={'crt_'+r}>
                <InputText placeholder={t('Criteria')+': '+r} value={crtName} onChange={(e)=>onCrtName(e,row)}/>
                <InputNumber placeholder={t('Score')} value={crtScore} onValueChange={(e)=>onCrtScore(e,row)}/>
                </th>);
            for(var c=1;c<=rubric.levelCount;c++)
            {
                const cl=c;
                cells.push(<td key={'descr_'+r+'_'+c}><InputTextarea rows={4} cols={22} 
                    value={rubric.descr[r-1][c-1]} onChange={(e)=>onDescrChange(e,row,cl)}/></td>);    
            }
            rows.push(<tr key={'descr_'+r}>{cells}</tr>);
        }
        return rows;
    }
    const getDescr=(r,c)=>{
        var dsc='';
        if(rubric.descr[r-1] != undefined)
        {
            if(rubric.descr[r-1][c-1] != undefined)
                dsc = rubric.descr[r-1][c-1];
        }
        return dsc;
    }
    const holistic=()=>{
        var rows=[];
        rows.push(<><th>{t('Criteria')}</th><th>{t('Score')}</th></>)
        for(var r=1;r<=rubric.criteriaCount;r++)
        {
            var cells=[];
            //cells.push(<th>{r}</th>);
            const row=r;
            const crtName=rubric.criteria[r-1]!=undefined?rubric.criteria[r-1].name:undefined;
            const crtScore=rubric.criteria[r-1]!=undefined?rubric.criteria[r-1].score:undefined;

            cells.push(<th><InputText style={{width:'20rem'}} placeholder={'Criteria: '+r} value={crtName} onChange={(e)=>onCrtName(e,row)}/></th>);
            cells.push(<th><InputNumber placeholder={'Score'} value={crtScore} onValueChange={(e)=>onCrtScore(e,row)}/></th>);
            rows.push(<tr>{cells}</tr>);
        }
        return rows;

    }
    const _onChange=(rb)=>{
        if(rb.descr.length<rb.criteriaCount)
        {
            rb.descr.length = rb.criteriaCount;
            rb.criteria.length = rb.criteriaCount;
        }
        else if(rb.descr.length>rb.criteriaCount)
        {
            rb.criteria = rb.criteria.slice(0,rb.criteriaCount);
            rb.descr = rb.descr.slice(0,rb.criteriaCount);
        }
        if(rb.levels.length<rb.levelCount)
            rb.levels.length = rb.levelCount;
        else if(rb.levels.length>rb.levelCount)
            rb.levels = rb.levels.slice(0,rb.levelCount);
    
        for(var r=0;r<rb.criteriaCount;r++)
        {
            if(rb.descr[r]==undefined)
                rb.descr[r]=new Array(rb.levelCount);
            if(rb.descr[r].length<rb.levelCount)                
                rb.descr[r].length=rb.levelCount;
            else if(rb.descr[r].length>rb.levelCount)
                rb.descr[r] = rb.descr[r].slice(0,rb.levelCount);
        }        
        onChange(rb);
    };
    const content=()=>{
        console.log("content:"+JSON.stringify(rubric));
        if(rubric.rubricType == 'ANALYTIC')
        {
            return(
                <table>
                <tbody>
                    <tr>{levelNames()}</tr> 
                    {rows()}
                    <tr>{scores()}</tr> 
                </tbody>
                </table>
            );
        }
        else
        {
            return(
                <table>
                    <tbody>
                    {holistic()}
                    </tbody>
                </table>
            );
        }
    }
    return(
        <>
            <div style={{overflow:'auto'}}>
                <Panel header={t('Rubric_structure')} className="col-12">
                <div style={{maxWidth:'600px'}}>
                <Form id="rubric" formData={rubric} columns="2" onChange={onChange}
                    fields={[
                        {id:"private",ftype:"checkbox",field:"private",label:t("Private_rubric")}
                    ]}>
                </Form>	    
                <Form id="rubric" formData={rubric} columns="2" onChange={onChange}
                    fields={[
                        {id:"rubricType",ftype:"dropdown",field:"rubricType",label:t("Rubric_Type"),options:rubricTypeOptions},
                        {id:"name",ftype:"text",field:"name",label:"Name",disabled:(rubric.private || !rubric.isnew)}
                    ]}>
                </Form>	
                <Form id="rubric" formData={rubric} columns="2" onChange={onChange}
                    fields={[
                        {id:"levelCount",ftype:(rubric.rubricType=='ANALYTIC'?'number':'none'),field:"levelCount",label:t("Levels"),step:1,min:2,max:9},
                        {id:"criteriaCount",ftype:"number",field:"criteriaCount",label:"Criteria",step:1,min:1,max:20}
                    ]}>
                </Form>	
                </div>
                </Panel>                
                <Panel header={t("Rubric_definition")} className="col-12">
                    {content()}
                </Panel>
            </div>
        </>
    );
}

export function RubricDialog({currentRubric,visible,onOK,onCancel})
{
    const {t}=useTranslation();    
    const descr=[];
    for(var r=0;r<3;r++)
    {
        var row=new Array(3);
        descr.push(row);
    }
    const [rubric,setRubric] = useState({rubricType:'ANALYTIC',levelCount:3,criteriaCount:3,private:true,name:'',isnew:true,levels:[],criteria:[],descr:descr});

    const onChange=(rb)=>{
        var rbr={...rb,rubric};
        setRubric(rbr);
    }
    const _onOK=()=>{
        onOK(rubric);
    }
    useEffect(()=>{
        if(currentRubric != undefined)
            setRubric(currentRubric);
    },[currentRubric])
    return(
        <CommonDialog header={t("Rubric")} visible={visible} onOK={_onOK} onCancel={onCancel}>
            <Rubric rubric={rubric} onChange={onChange}/>
        </CommonDialog>
    );
}